(function () {
    'use strict';

    angular
        .module('backApp')
        .controller('ProcessSpotColorDialogController', ProcessSpotColorDialogController);

    ProcessSpotColorDialogController.$inject = ['$scope', '$uibModalInstance', 'entity', 'Process'];

    function ProcessSpotColorDialogController($scope, $uibModalInstance, entity, Process) {
        var vm = this;

        vm.process = entity;
        vm.operationValues = angular.copy(vm.process.operationValues || []);
        vm.clear = clear;
        vm.save = save;
        vm.addOperationValue = addOperationValue;
        vm.removeOperationValue = removeOperationValue;
        vm.quantityType = (vm.process.type == 'HOT_STAMP' || vm.process.type == 'UV' || vm.process.type == 'FLUORESCENT' ) ? 'MULTIPLE' : 'SINGLE'

        function addOperationValue() {
            vm.operationValues.push({
                alias: '',
                spotColor: '',
                color: '#000000',
                seq: vm.operationValues.length + 1,
                cancelled: false
            });
        }

        function removeOperationValue(index) {
            vm.operationValues.splice(index, 1);
            // angular.forEach(vm.operationValues, function (item, idx) {
            //     item.seq = idx + 1;
            // });
        }

        function save() {
            vm.isSaving = true;
            vm.process.operationValues = vm.operationValues;
            var data = {
                id: vm.process.id,
                name: vm.process.name,
                alias: vm.process.alias,
                type: vm.process.type,
                quantityType: vm.process.quantityType,
                spotColor: vm.process.spotColor,
                epitaxy: vm.process.epitaxy,
                epitaxyValue: vm.process.epitaxyValue,
                remark: vm.process.remark,
                unit: vm.process.unit,
                cancelled: vm.process.cancelled || false,
                origin: 'STORE',
                operationValues: vm.process.operationValues || []
            };
            if (data.id) {
                Process.update(data, onSaveSuccess, onSaveError);
            } else {
                Process.save(data, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('backApp:processUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
